import CardList from 'components/CardList';
import ImageWithFallback from 'components/ImageWithFallback';
import { winnerPhotoNames } from 'constants/winnerPhotoNames';
import React from 'react';

const WinnersWallOfFame = () => (
  <div className="winnersWallOfFame fullWidth flexCentered md:px-1">
    <CardList id="wallOfFame" noDots>
      {winnerPhotoNames.map((name) => (
        <div key={name} className="gridPhotoWrapper fullWidth flexCentered">
          <ImageWithFallback
            src={`/images/winners/wall-of-fame/${name}.webp`}
            fallbackSrc={`/images/winners/wall-of-fame/${name}.jpg`}
            className="gridPhoto"
            layout="fill"
            alt="DAYMADE winner"
            width={undefined}
          />
        </div>
      ))}
    </CardList>

    <style jsx>
      {`
        :global(#wallOfFame) {
          width: 100%;
          flex-direction: column;
          flex-wrap: wrap;
          height: auto;
          max-height: 430px;
          padding: 0;
        }

        .gridPhotoWrapper {
          position: relative;
          margin: 5px;
          width: 150px;
          height: 150px;
        }

        @media (min-width: 1000px) {
          .gridPhotoWrapper {
            width: 200px;
            height: 200px;
          }
        }

        @media (min-width: 1600px) {
          :global(#wallOfFame) {
            max-height: 530px;
          }

          .gridPhotoWrapper {
            width: 250px;
            height: 250px;
          }
        }
      `}
    </style>
  </div>
);

export default WinnersWallOfFame;
